import { ExternalLink, Sparkles } from "lucide-react";

export default function MasterclassUpsell() {
  return (
    <div
      className="mt-4 p-5 rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 animate-fade-in-up"
      data-testid="masterclass-upsell"
    >
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-5 h-5 text-amber-600" />
        <h3 className="text-sm font-bold text-gray-900">
          Bouquet Cake Masterclass
        </h3>
      </div>
      <p className="text-sm text-gray-700 font-medium mb-2">
        Learn how to make buttercream flower bouquet cakes from scratch!
      </p>
      <ul className="text-xs text-gray-600 space-y-1.5 mb-4">
        <li className="flex items-start gap-1.5">
          <span className="text-amber-500 mt-0.5">&#10003;</span>
          Get Instant Access — Buy module-wise content & learn as you go
        </li>
        <li className="flex items-start gap-1.5">
          <span className="text-amber-500 mt-0.5">&#10003;</span>
          Signature recipes by Sugar Bouquet India
        </li>
        <li className="flex items-start gap-1.5">
          <span className="text-amber-500 mt-0.5">&#10003;</span>
          Exclusive Video content + PDF resources + Affordable pricing
        </li>
      </ul>
      <a
        href="https://sites.google.com/view/bouquet-cakes-masterclass/home-page"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-amber-600 text-white text-sm font-semibold hover:bg-amber-700 transition-colors"
        data-testid="masterclass-link"
      >
        <ExternalLink className="w-4 h-4" />
        Start Learning Now
      </a>
    </div>
  );
}
